import { render, staticRenderFns } from "./buyTicket.vue?vue&type=template&id=ef248b0a&scoped=true&"
import script from "./buyTicket.vue?vue&type=script&lang=js&"
export * from "./buyTicket.vue?vue&type=script&lang=js&"
import style0 from "./buyTicket.vue?vue&type=style&index=0&id=ef248b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef248b0a",
  null
  
)

export default component.exports